import React from 'react';
import TierPageBanner from './TierPageBanner';
import MarketThesis from '../MarketThesis';

const TierThesisWrapper: React.FC = () => (
  <div>
    <TierPageBanner
      title="Market thesis · tier map"
      description="Directional theses drive position selection across the stack. Long horizons feed Tier 1 macro; short horizons feed active options tiers."
      thesisTimeframe="1_2_weeks"
    />
    <MarketThesis />
  </div>
);

export default TierThesisWrapper;
